import React from "react";
import { CircularProgress, Container } from "@mui/material";

const OurLoader = () => {
  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <CircularProgress />
    </Container>
  );
};

export default OurLoader;
